import { dateToString } from '~/helpers/dateToString';
import formatPrice from '~/helpers/formatPrice';
import { PackageCalendarResponse } from '~/types/api';

export type DayState = {
  date: Date;
  availability?: 'AV' | 'RQ' | 'NA' | 'SS' | null;
  price: string | undefined;
  pricePerPerson: string | undefined;
  priceRaw: number | undefined;
  pricePerPersonRaw: number | undefined;
};

export default function useDayStateForDate(calendarAvailabilities?: PackageCalendarResponse['availabilities']) {
  return (date: Date | null): DayState | null => {
    if (!date) {
      return null;
    }

    let dayState: DayState | null = null;

    // Loop through all prices from the API
    calendarAvailabilities?.forEach((dayAvailability) => {
      // If the date matches, set the price
      if (dayAvailability.date === dateToString(date)) {
        dayState = {
          date,
          availability: dayAvailability.availability,
          price: dayAvailability.price
            ? formatPrice(dayAvailability.price, 'short')
            : undefined,
          pricePerPerson: dayAvailability.pricePerPerson
            ? formatPrice(dayAvailability.pricePerPerson, 'short')
            : undefined,
          priceRaw: dayAvailability.price ?? undefined,
          pricePerPersonRaw: dayAvailability.pricePerPerson ?? undefined,
        };
      }
    });

    return dayState;
  };
}
